import { HttpClient, HttpRequest, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ConfigService } from '../config/config.service';
import { HttpErrorService } from '../http-error.service';
import { ToastrService } from 'ngx-toastr';
import { catchError, map } from 'rxjs/operators';
import { of } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ForcedRecordingMapRequestService {

  constructor(
    private http: HttpClient,
    private configService: ConfigService,
    private httpErrorService: HttpErrorService,
    private toastrService: ToastrService) {

    }

  // NOTE: endpoint name assumed — backend work (subtask handled separately) to expose this.
  requestMany(deviceIds: string[]) {
      const url = this.configService.API_URI + '/RecordingMapRequests/RequestMany';
      const req = new HttpRequest('POST', url, deviceIds);

      return this.http.request(req).pipe(
        map((res) => {
          if (res instanceof HttpResponse) {
            this.toastrService.success('Recording map upload successfully requested.', 'Success');
            return res;
          }
        }),
        catchError((err) => {
          this.httpErrorService.handleHttpError(err);
          return of(err);
        })
      );
  }
}
